module.exports = __webpack_public_path__ + "o.no1.6911bc14.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/kanai/female_to_male/o.no1.jpg
// module id = BjNe
// module chunks = 0